<template>
  <div class="select-container">
    <div class="placeholder" @click="selecting = !selecting">
      <p v-if="!afterSelectItem.length">Select {{ name }}</p>
      <p class="selected" v-else>{{ afterSelectItem }}</p>
    </div>
    <div class="select-list-container" v-if="selecting" v-click-outside="() => selecting = false">
      <div class="search">
        <input type="text" class="input" placeholder="Search" v-model="search" />
      </div>
      <div class="select-list">
        <ul>
          <li :class="[{ 'checked': i.check }]" v-for="(i, index) in getSelectItem" :key="index" @click="setToItem(i)">
            <span></span>
            <p>{{ i.name }}</p>
          </li>
        </ul>
      </div>
      <div class="buttons">
        <!-- <button class="button grey" @click="selecting = false">Cancel</button>
        <button class="button primary" @click="selecting = false">Save</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: ['name', 'info', 'updateText'],
  data: () => ({
    selecting: false,
    search: "",
    selectItem: []
  }),
  computed: {
    getSelectItem() {
      return this.info.filter((i) => {
        return i.name.toLowerCase().match(this.search.toLowerCase());
      })
    },
    afterSelectItem() {
      const mapName = (arr) => arr.map((i) => i)
      return mapName(this.selectItem.map((i) => i.name)).join(', ')
    }
  },
  methods: {
    setToItem(obj) {
      if (obj && obj.check) {
        this.info.forEach((el, indx) => {
          if (el._id === obj._id) {
            this.info[indx].check = false
          }
        })
        this.selectItem.forEach((o, idx) => {
          if (o._id === obj._id) this.selectItem.splice(idx, 1);
        })
      } else {
        this.info.forEach((el, indx) => {
          if (el._id === obj._id) {
            this.info[indx].check = true
            this.selectItem.push(obj)
          }
        })
      }
    },
    afterRender() {
      this.selectItem.map((i) => {
        this.info.forEach((el, indx) => {
          if (el._id === i._id) {
            this.info[indx].check = true
          }
        })
      })
    }
  },
  watch: {
    updateText() {
      this.selectItem = this.updateText
      setTimeout(() => {
        this.afterRender()
      }, 800)
    },
    selectItem: {
      handler(val) {
        if (val.length) {
          this.$emit('input', val)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-container {
  position: relative;

  .placeholder {
    font-size: 1rem;
    height: 2.5em;
    justify-content: flex-start;
    display: flex;
    align-items: center;
    line-height: 1.5;
    padding-bottom: calc(0.5em - 1px);
    padding-left: calc(0.75em - 1px);
    padding-right: 30px;
    padding-top: calc(0.5em - 1px);
    background-color: var(--light-grey-color);
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: var(--radius);
    position: relative;

    &:hover {
      background-color: rgba(#000, 0.15) !important;
    }

    &::after {
      content: "";
      display: block;
      border-left: solid 6px transparent;
      border-right: solid 6px transparent;
      border-top: solid 6px var(--dark-grey-color);
      height: 0;
      width: 0;
      position: absolute;
      right: 10px;
    }

    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 0;
    }
  }

  .select-list-container {
    box-shadow: 0 0 10px 5px rgba(#000, 0.05);
    overflow: hidden;
    position: absolute;
    z-index: 9;
    width: 100%;
    background-color: #fff;
    border-radius: var(--radius);
    border: 1px solid var(--border-color);
    max-height: 300px;
    display: flex;
    flex-direction: column;

    .search {
      padding: 10px 15px;
      border-bottom: 1px solid var(--border-color);
    }

    .select-list {
      overflow-y: auto;

      ul {
        list-style-type: none;
        margin: 0;
        padding: 10px 0;

        li {
          padding: 20px 15px;
          cursor: pointer;
          height: 2rem;
          display: flex;
          align-items: center;
          gap: 10px;

          &:hover {
            background-color: rgba(var(--primary-color-rgb), 0.09);
            color: var(--primary-color);
          }

          &.checked {
            span {
              line-height: 0;
              background: var(--primary-color);

              &::after {
                border-color: #fff;
              }
            }
          }

          span {
            content: "";
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 20px;
            height: 20px;
            background: var(--grey-color);

            &::after {
              content: "";
              position: absolute;
              top: 3px;
              transform: rotate(45deg);
              height: 10px;
              width: 5px;
              border-bottom: 2px solid var(--light-grey-color);
              border-right: 2px solid var(--light-grey-color);
            }
          }

          p {
            transition: all ease-in-out 0.15s;
          }
        }
      }
    }

    .buttons {
      padding: 10px 15px;
      border-top: 1px solid var(--border-color);
      background-color: var(--light-grey-color);
    }
  }
}
</style>
